import { useMutation } from '@tanstack/react-query';
import toast from 'react-hot-toast';

import { recaptchaV3 } from '@/services/nextjs-api/recaptcha-v3';

const RECAPTCHA_SITE_KEY = process.env.NEXT_PUBLIC_RECAPTCHA_SITE_KEY ?? '';

export const useRecaptchaV3 = ({ action }: { action: string }) => {
  const { mutateAsync, isLoading } = useMutation({
    mutationFn: recaptchaV3,
    mutationKey: ['recaptchaV3', action],
  });

  const verifyRecaptchaV3 = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const token = await grecaptcha.execute(RECAPTCHA_SITE_KEY, { action });

    const data = await mutateAsync({ action, token });

    if (!data?.success) {
      toast.error(
        'Our system has detected you as a bot. If you are not a bot, you can contact us at hello@mindpal.co'
      );
      return { isVerified: false };
    }

    return { isVerified: true };
  };

  return {
    isLoading,
    verifyRecaptchaV3,
  };
};
